import { Button, Flex, Image, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { SelectableGiftCardType } from './GiftCard'
import { useState } from 'src/hooks'
import { GiftCardAmountSelection } from './GiftCardAmountSelection'
import { DigitalGiftCardProduct } from 'src/graphql/generated/graphql'
import { useMarketingContent } from 'src/react_query'

type GiftCardPreviewProps = {
  onSelect: (giftCard: SelectableGiftCardType) => Promise<void>
  selectedGiftCard: DigitalGiftCardProduct
}

export const GiftCardPreview: React.FC<GiftCardPreviewProps> = ({
  onSelect,
  selectedGiftCard,
}) => {
  const [stagedGiftCard, setStagedGiftCard] = useState<SelectableGiftCardType>({
    code: selectedGiftCard.code,
    title: selectedGiftCard.title,
    imageUrl: selectedGiftCard.image ?? '',
    amount: selectedGiftCard.minimumAmount
      ? Number(selectedGiftCard.minimumAmount)
      : 10,
    currency: selectedGiftCard.currency ?? 'USD',
  })
  const [isPending, setIsPending] = useState(false)

  const { data: marketingContent } = useMarketingContent()

  return (
    <Flex flexDirection="column" width="100%">
      <Flex
        justifyContent="center"
        alignItems="center"
        backgroundColor="#d9d9d9"
        inset={{ vertical: 'x6' }}
      >
        <Image
          image={{ url: stagedGiftCard.imageUrl }}
          width="300px"
          height="200px"
          isActive={true}
          borderRadius="medium"
        />
      </Flex>
      <div style={{ marginTop: '2rem', marginBottom: '1rem' }}>
        <Text
          type="body"
          content={marketingContent?.giftCardSetupTitle.content}
          alignment="center"
        />
      </div>
      <GiftCardAmountSelection
        amounts={
          (selectedGiftCard.fixedAmounts?.map(value => Number(value)) ??
          (selectedGiftCard.minimumAmount &&
            parseInt(selectedGiftCard.minimumAmount) <= 5))
            ? [5, 10]
            : [10]
        }
        activeAmount={stagedGiftCard.amount}
        onNewAmount={(amount: number) => {
          setStagedGiftCard({ ...stagedGiftCard, amount: amount })
        }}
        minAmount={
          selectedGiftCard.minimumAmount
            ? parseInt(selectedGiftCard.minimumAmount)
            : 10
        }
        maxAmount={
          selectedGiftCard.maximumAmount
            ? parseInt(selectedGiftCard.maximumAmount)
            : 10
        }
      />

      <Flex width="100%" style={{ marginTop: '50px', padding: '0 1rem' }}>
        <Button
          fullWidth={true}
          backgroundColorOverride="#404040"
          onClick={async () => {
            setIsPending(true)
            try {
              await onSelect(stagedGiftCard)
            } finally {
              setIsPending(false)
            }
          }}
          fontWeight="semiBold"
          title={isPending ? 'Adding your Gift Card...' : 'Add Gift Card'}
          disabled={isPending}
        />
      </Flex>
    </Flex>
  )
}
